import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  loading = false;
  successMessage = '';
  errorMessage = '';
  token: string = '';
  showPassword = false;
  showConfirmPassword = false;
  passwordReset = false;

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.resetForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    // Pegar token da URL
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      if (!this.token) {
        this.errorMessage = 'Token inválido ou ausente. Solicite um novo link de recuperação.';
      }
    });
  }

  passwordMatchValidator(form: FormGroup) {
    const pw = form.get('password')?.value;
    const cpw = form.get('confirmPassword')?.value;
    return pw && cpw && pw !== cpw ? { passwordMismatch: true } : null;
  }

  onSubmit(): void {
    if (this.resetForm.invalid) {
      this.resetForm.markAllAsTouched();
      return;
    }

    if (!this.token) {
      this.errorMessage = 'Token inválido. Solicite um novo link de recuperação.';
      return;
    }

    this.loading = true;
    this.errorMessage = '';
    this.successMessage = '';

    const newPassword = this.resetForm.value.password;

    this.api.resetPassword(this.token, newPassword).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.success) {
          this.passwordReset = true;
          this.successMessage = 'Senha redefinida com sucesso! Redirecionando para o login...';
          setTimeout(() => this.router.navigate(['/login']), 3000);
        } else {
          this.errorMessage = res.message || 'Erro ao redefinir senha';
        }
      },
      error: (err: any) => {
        this.loading = false;
        this.errorMessage = err.error?.message || 'Token inválido ou expirado. Solicite um novo link de recuperação.';
      }
    });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }

  get f() { return this.resetForm.controls; }
}
